import {ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef}     from "@angular/material/dialog";
import {Store}                                              from "@ngrx/store";
import {ISpinnerState}                                      from "../../../../../shared/ngrx/store/state/spinner.state";
import {MatIconModule}                                      from "@angular/material/icon";
import {MatButtonModule}                                    from "@angular/material/button";

@Component({
               selector:        'app-dialog-alert-no-result',
               templateUrl:     './dialog-alert-no-result.component.html',
               styleUrls:       ['./dialog-alert-no-result.component.scss'],
               changeDetection: ChangeDetectionStrategy.OnPush,
             standalone:      true,
             imports: [
               MatIconModule,
               MatDialogModule,
               MatButtonModule,
             ],
             providers:       []
           })
export class DialogAlertNoResultComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<DialogAlertNoResultComponent>,
        public _store: Store<ISpinnerState>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
    }

    ngOnInit(): void {
    }

}
